const angular = require('angular')

module.exports = [
  'User',
  '$timeout',
  '$rootScope',
  function(User, $timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function($scope, elem, attrs) {
        /** 根据配置渲染水印 */
        /** render watermark according to the settings */
        if (!$rootScope.settings.watermark) return

        const canvases = {}
        function drawWaterMark() {
          let canvas, context

          const $composeContentElem = angular.element(elem)
          let $contentElem = $composeContentElem.find('ng-include')
          $contentElem = !$contentElem.length ? $composeContentElem : $contentElem

          if (canvases[$scope.id]) {
            canvas = canvases[$scope.id]
            context = canvas.getContext('2d')
            context.clearRect(0, 0, canvas.width, canvas.height)
          } else {
            const $canvas = angular.element('<canvas class="watermark"></canvas>')
            $contentElem.append($canvas)
            canvas = $canvas[0]
            context = canvas.getContext('2d')
            canvases[$scope.id] = canvas
          }

          $timeout(function() {
            /** 部分浏览器需要等待 canvas 渲染后才能进行绘图 */
            /** some browsers will need to fill or stroke after canvas has been rendered */
            const clientWidth = canvas.width = $contentElem[0].clientWidth
            const clientHeight = canvas.height = Math.max(
              $composeContentElem[0].clientHeight,
              $contentElem[0].clientHeight
            )

            const userConfig = User.getConfig()
            const sita = Math.PI / 8
            const globalAlpha = 0.025

            for (let x = -1; x <= 1; x++) {
              let pivot = ((0.6 + x) * clientWidth) / 2
              for (let y = 0; y < clientHeight; y += 0.5 * clientWidth) {
                context.save()
                context.globalAlpha = globalAlpha

                /** 偶数行偏移 */
                /** translate pivot when it is an even row */
                const isEvenRow = (y / 0.5 / clientWidth + 1) % 2 === 1
                pivot += isEvenRow ? 0 : 0.25 * clientWidth
                context.translate(pivot, y)

                context.rotate(-sita)
                context.textAlign = 'left'

                /** 防止文字过长导致溢出 */
                /** Prevent overflow caused by too long text */
                let textWidth, fontSize, lineHeight
                textWidth = fontSize = lineHeight = 40 / 800 * clientWidth
                do {
                  fontSize *= 0.8
                  lineHeight = fontSize * 1
                  context.font = fontSize + "px '微软雅黑'"
                  textWidth =
                    Math.max(
                      context.measureText(userConfig.true_name).width,
                      context.measureText(userConfig.primary_email).width
                    ) * Math.cos(sita)
                } while (textWidth > clientWidth)

                const dx = (0.2 * clientWidth - textWidth / 2) / Math.cos(sita)
                const dy = ((dx + textWidth / 2) * Math.cos(sita) + 0.2 * clientWidth + fontSize) * Math.cos(sita)

                context.fillStyle = 'black'
                userConfig.true_name && context.fillText(userConfig.true_name, dx - dy, dy)
                context.fillText(
                  userConfig.primary_email,
                  dx - dy,
                  dy + lineHeight
                )

                /** prevent color reduplication */
                context.strokeStyle = 'white'
                userConfig.true_name && context.strokeText(userConfig.true_name, dx - dy, dy)
                context.strokeText(
                  userConfig.primary_email,
                  dx - dy,
                  dy + lineHeight
                )
                context.restore()
              }
            }
          }, 0)
        }

        $scope.$on(attrs.watermark.toUpperCase() + '.CONTENT_LOADED', drawWaterMark)
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/directives/watermark.js